import styled from 'styled-components';
import { Button, Text } from '@kl/components-v6';
import { LocalizedButton } from 'shared/ui/localized-button';

export const StyledCookieDialogContainer = styled.div`
    position: relative;
    padding: 16px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: var(--color--yellow_50);

    @media (max-width: 768px) {
        padding: 25px 16px 16px;
    }
`;

export const StyledCookieMessage = styled(Text)`
    color: var(--color--yellow_600);
`;

export const StyledContentContainer = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
    flex-wrap: nowrap;
    max-width: 1280px;
    margin: 0 auto;

    @media (max-width: 768px) {
        flex-direction: column;
        flex-wrap: wrap;
        gap: 8px;
        align-items: start;
    }
`;

export const StyledAcceptButton = styled(LocalizedButton)`
    flex-shrink: 0;
`;

export const StyledCloseButton = styled(Button)`
    @media (max-width: 768px) {
        position: absolute;
        top: 5px;
        right: 5px;
    }
`;
